import { useMemo } from "react";
import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import * as Notify from "@repoflow/form-schema/notify";
import * as EntryQL from "queries/entry";
import { Component as Form } from "@repoflow/form-schema";
import { Mutation, Button, useSectionContext } from "@repoflow/components/section";
import * as appWidgets from "@shared/widgets/register";
import { MEALS } from "@common/schema/entry/fields";
import { mealOptions } from "components/day/summary";
import { useMeals } from "components/settings/meals";

export const Sidebar = () => null;

export const Indice = () => <BreadcrumbItem>Edit</BreadcrumbItem>;

// Built per set of meal options for the reason routes/day/new gives. No
// `date`: it is the front of the key, so an entry logged on the wrong day is
// removed and added again.
const fieldsFor = (options) => ({
  "/Public/Entry/Update": {
    fields: [
      { property: "food" },
      { property: "serving" },
      { property: "meal", options },
      { property: "calories" },
      { property: "protein" },
      { property: "carbs" },
      { property: "fat" },
      { property: "fiber" },
    ],
  },
});

export const Content = ({ match: { params: { entryId } } }) => {
  const history = useHistory();
  const { values } = useSectionContext();
  const date = values?.date;

  return (
    <Mutation
      target={{ $ref: "/Public/Entry/Update" }}
      mutation={EntryQL.edit}
      update={EntryQL.update()}
      onMutate={({ handler, state: { values: current } }) => {
        // Only what the update input declares. The route's query seeds the form
        // with the whole row — entryId, date, timestamps — and EntryInputUpdate
        // would refuse the extra fields.
        const { meal, food, serving, calories, protein, carbs, fat, fiber } = current;
        handler({ variables: { entryId, input: { meal, food, serving, calories, protein, carbs, fat, fiber } } });
      }}
      onCompleted={() => {
        history.replace(date ? `/day/${date}` : `/day`);
      }}
      onError={(error) => {
        Notify.error(error.toString());
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

// The meals shown, and the entry's own meal when it is a hidden one: an entry
// logged before its meal was turned off can be edited without being moved.
// The meal as it was READ (`initial`), not as the form now holds it, so
// picking another meal does not take the hidden one out from under the cursor.
const MutationHandler = ({ schema, state, mutate, target, base, initial }) => {
  const { values, setValues } = state;
  const shown = useMeals() || MEALS;
  const fields = useMemo(() => fieldsFor(mealOptions(shown, initial?.meal)), [shown, initial?.meal]);

  return (
    <Container className="mt-4" style={{ maxWidth: 760 }}>
      <Row>
        <Col>
          <Form
            schema={schema}
            target={target}
            values={values}
            widgets={appWidgets}
            config={fields}
            onSubmit={() => mutate()}
            onChange={(vals) => setValues(vals)}
          >
            <Button type="submit">Save</Button>{" "}
            <Link className="btn btn-outline-danger" to={`${base}/remove`}>
              Remove
            </Link>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};
